import server from "../Server";
import { ResetPasswordPayload } from "../../../gateways";
import withErrorCheck from "../CheckError";

export const ResetPassword = async (params: ResetPasswordPayload): Promise<boolean> => {
  withErrorCheck(
    await server.auth.setSession({
      access_token: params.access_token,
      refresh_token: params.refresh_token,
    })
  );

  const { user } = withErrorCheck(await server.auth.updateUser({ password: params.password }));

  try {
    if (user?.email && user?.id) {
      const resp = await server
        .from("Players")
        .update({ user_id: user.id })
        .eq("email", user.email)
        .is("user_id", null);
    }
  } catch (error) {
    console.log("Error Update", error);
  }

  await server.auth.signOut();

  return !!user;
};
